/**
 * Frontend mirrors of AccountTypeCatalog helpers for journal / GL UX.
 * Keep in sync with backend/app/Libraries/AccountTypeCatalog.php.
 */

import { getStoredAccountingBackend } from "../../config/accounting";

const ZOHO_EXPENSE = ["expense", "other_expense", "cost_of_goods_sold"] as const;
const TALLY_EXPENSE = [
  "direct_expenses",
  "indirect_expenses",
  "purchase_accounts",
] as const;
const ZOHO_INCOME = ["income", "other_income"] as const;
const TALLY_INCOME = [
  "direct_incomes",
  "indirect_incomes",
  "sales_accounts",
] as const;

function backend(): "zoho" | "tally" {
  return getStoredAccountingBackend() === "tally" ? "tally" : "zoho";
}

/** ES5-safe membership check (tsconfig lib is es6; Array.includes needs es2016). */
function listHas(list: readonly string[], value: string): boolean {
  return list.indexOf(value) !== -1;
}

export function isApAccountType(accountType: string): boolean {
  return accountType.trim().toLowerCase() === "accounts_payable";
}

export function isArAccountType(accountType: string): boolean {
  return accountType.trim().toLowerCase() === "accounts_receivable";
}

export function isExpenseAccountType(accountType: string): boolean {
  const type = accountType.trim().toLowerCase();
  const list = backend() === "tally" ? TALLY_EXPENSE : ZOHO_EXPENSE;
  return listHas(list, type);
}

export function isIncomeAccountType(accountType: string): boolean {
  const type = accountType.trim().toLowerCase();
  const list = backend() === "tally" ? TALLY_INCOME : ZOHO_INCOME;
  return listHas(list, type);
}

/** Zoho classic Bad Debt lives on account_type=expense; Tally may use any expense-family slug. */
export function isBadDebtAccountTypeCandidate(accountType: string): boolean {
  const type = accountType.trim().toLowerCase();
  if (type === "expense") {
    return true;
  }
  return backend() === "tally" && isExpenseAccountType(type);
}
